<template>
    <div class="upload-picture-modal">
        <b-modal
                id="image-viewer-popup"
                title="Document Preview"
                size="md"
                ok-only
                ok-title="Close"
                ok-variant="primary"
                no-close-on-backdrop
                no-close-on-esc
                @hide="onModalHide"
        >

            <div class="document-preview-section">
                <img v-authenticated-image="item.fileName" />
            </div>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        components: {
        },
        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            item: {
                type: Object,
                default: null,
            },
        }, // End of Component > props
        data() {
            return {
                imgSrc: process.env.VUE_APP_FILE_SERVICE_URL + this.item.fileName,
                pageCount: []
            }
        },

        methods: {
            onClose(){ this.$refs['imageViewer'].hide()
            },
            onClick() {
                axios({
                    url: this.imgSrc,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', this.item.fileName);
                    document.body.appendChild(fileLink);

                    fileLink.click();
                });
            }
        },
        onModalHide() {
            this.$emit('reset-preview-document');
        },
    }
</script>
